import React from "react";
import { AfishaEvent, buildDayMeta } from "./afishaUtils";
import { AfishaTrack } from "./AfishaTrack";

type DayMeta = ReturnType<typeof buildDayMeta>;

type AfishaFilterDaysProps = {
  days: DayMeta[];
  eventsByDate: Record<string, AfishaEvent[]>;
  loading?: boolean;
  emptyText?: string;
};

export const AfishaFilterDays = ({
  days,
  eventsByDate,
  loading,
  emptyText = "В выбранной категории нет событий на ближайшие дни",
}: AfishaFilterDaysProps) => {
  if (loading) {
    return <p className="afisha__status">Загрузка событий…</p>;
  }

  const daysWithEvents = days.filter(
    (day) => (eventsByDate[day.date]?.length ?? 0) > 0,
  );

  if (!daysWithEvents.length) {
    return (
      <p className="afisha__empty">{emptyText}</p>
    );
  }

  return (
    <div className="afisha-filter-days" aria-label="События по дням">
      {daysWithEvents.map((day) => {
        const events = eventsByDate[day.date] ?? [];
        const dayLabel = `${day.weekday}, ${day.dayNum} ${day.monthLabel}`;

        return (
          <section key={day.date} className="afisha-filter-days__section">
            <h2 className="afisha-filter-days__label">{dayLabel}</h2>
            <div className="afisha-filter-days__events">
              {events.map((event) => (
                <AfishaTrack key={`${day.date}-${event.id}`} event={event} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
};
